var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "20005AEA-42FE-45FE-B345-963D418ADA97") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "discursivas-detalhes/verde",
    transform: "translate(-445.000000, -518.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aula0",
    transform: "translate(312.000000, 332.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-download",
    transform: "translate(133.000000, 186.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#83F367",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(3.000000, 3.000000)",
    fill: "#FF6A58",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,11 C18.5128358,11 18.9355072,11.3860402 18.9932723,11.8833789 L19,12 L19,16 C19,17.5976809 17.75108,18.9036609 16.1762728,18.9949073 L16,19 L2,19 C0.402319117,19 -0.903660879,17.75108 -0.994907307,16.1762728 L-1,16 L-1,12 C-1,11.4477153 -0.55228475,11 0,11 C0.512835839,11 0.935507161,11.3860402 0.993272269,11.8833789 L1,12 L1,16 C1,16.5128358 1.38604019,16.9355072 1.88337887,16.9932723 L2,17 L16,17 C16.5128358,17 16.9355072,16.6139598 16.9932723,16.1166211 L17,16 L17,12 C17,11.4477153 17.4477153,11 18,11 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29289322,6.29289322 C3.65337718,5.93240926 4.22060824,5.90467972 4.61289944,6.20970461 L4.70710678,6.29289322 L9,10.585 L13.2928932,6.29289322 C13.6533772,5.93240926 14.2206082,5.90467972 14.6128994,6.20970461 L14.7071068,6.29289322 C15.0675907,6.65337718 15.0953203,7.22060824 14.7902954,7.61289944 L14.7071068,7.70710678 L9.70710678,12.7071068 C9.34662282,13.0675907 8.77939176,13.0953203 8.38710056,12.7902954 L8.29289322,12.7071068 L3.29289322,7.70710678 C2.90236893,7.31658249 2.90236893,6.68341751 3.29289322,6.29289322 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,-1 C9.51283584,-1 9.93550716,-0.61395981 9.99327227,-0.116621125 L10,0 L10,12 C10,12.5522847 9.55228475,13 9,13 C8.48716416,13 8.06449284,12.6139598 8.00672773,12.1166211 L8,12 L8,0 C8,-0.55228475 8.44771525,-1 9,-1 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownload);
export default __webpack_public_path__ + "static/media/ic-download.7a7399e3695e911fd01cf8ecfd2b9fcd.svg";
export { ForwardRef as ReactComponent };